import PERFIL from './PERFIL'

const AGENDAMENTO_MARCADO = 'agendamento_marcado'
const AGENDAMENTO_ASSINADO = 'agendamento_assinado'
const AGENDAMENTO_FALTOU_SEM_JUSTIFICATIVA =
  'agendamento_faltou_sem_justificativa'
const AGENDAMENTO_EVOLUIDO = 'agendamento_evoluido'
const AGENDAMENTO_PRE_AGENDADO = 'agendamento_pre_agendado'
const ENCAIXAR_HORARIO = 'encaixar_horario'
const REPETIR_AGENDAMENTO = 'repetir_agendamento'
const PRONTUARIO_AGENDAMENTO = 'prontuario_agendamento'
const BLOQUEAR_GUIA = 'bloquear_guia'
const DESBLOQUEAR_GUIA = 'desbloquear_guia'
const TROCAR_SENHA = 'trocar_senha'
const EVOLUCAO_PACIENTE = 'evolucao_paciente'
const ALTERAR_GUIA_AGENDAMENTO = 'alterar_guia_agendamento'

export default {
  AGENDAMENTO_MARCADO,
  AGENDAMENTO_ASSINADO,
  AGENDAMENTO_FALTOU_SEM_JUSTIFICATIVA,
  AGENDAMENTO_EVOLUIDO,
  AGENDAMENTO_PRE_AGENDADO,
  ENCAIXAR_HORARIO,
  REPETIR_AGENDAMENTO,
  PRONTUARIO_AGENDAMENTO,
  BLOQUEAR_GUIA,
  DESBLOQUEAR_GUIA,
  TROCAR_SENHA,
  valores: [
    {
      nome: AGENDAMENTO_MARCADO,
      perfil: {
        permitir: [
          PERFIL.RECEPCIONISTA,
          PERFIL.FATURISTA,
          PERFIL.PROFISSIONAL,
          PERFIL.ADMINISTRADOR,
          PERFIL.GERENTE,
        ],
      },
    },
    {
      nome: AGENDAMENTO_ASSINADO,
      perfil: {
        permitir: [
          PERFIL.RECEPCIONISTA,
          PERFIL.FATURISTA,
          PERFIL.ADMINISTRADOR,
          PERFIL.GERENTE,
        ],
      },
    },
    {
      nome: AGENDAMENTO_FALTOU_SEM_JUSTIFICATIVA,
      perfil: {
        permitir: [
          PERFIL.RECEPCIONISTA,
          PERFIL.FATURISTA,
          PERFIL.PROFISSIONAL,
          PERFIL.ADMINISTRADOR,
          PERFIL.GERENTE,
        ],
      },
    },
    {
      nome: AGENDAMENTO_EVOLUIDO,
      perfil: {
        permitir: [PERFIL.PROFISSIONAL, PERFIL.ADMINISTRADOR, PERFIL.GERENTE],
      },
    },
    {
      nome: AGENDAMENTO_PRE_AGENDADO,
      perfil: {
        permitir: [
          PERFIL.RECEPCIONISTA,
          PERFIL.FATURISTA,
          PERFIL.PROFISSIONAL,
          PERFIL.ADMINISTRADOR,
          PERFIL.GERENTE,
        ],
      },
    },
    {
      nome: ENCAIXAR_HORARIO,
      perfil: {
        permitir: [
          PERFIL.RECEPCIONISTA,
          PERFIL.FATURISTA,
          PERFIL.PROFISSIONAL,
          PERFIL.ADMINISTRADOR,
          PERFIL.GERENTE,
        ],
      },
    },
    {
      nome: PRONTUARIO_AGENDAMENTO,
      perfil: {
        permitir: [
          PERFIL.RECEPCIONISTA,
          PERFIL.FATURISTA,
          PERFIL.PROFISSIONAL,
          PERFIL.ADMINISTRADOR,
          PERFIL.GERENTE,
        ],
      },
    },
    {
      nome: REPETIR_AGENDAMENTO,
      perfil: {
        permitir: [
          PERFIL.RECEPCIONISTA,
          PERFIL.FATURISTA,
          PERFIL.ADMINISTRADOR,
          PERFIL.GERENTE,
        ],
      },
      usuario: {
        permitir: [
          // Profissionais que atendem Urologia, Pilates e RPG,
          // assim como solicitado pela Clarissa.
          'nataliasoledade@gmail.com',
          'anapaulamachadofisio@gmail.com',
          'claudetemonteiropilates@gmail.com',
          'kelicris.alencar@gmail.com',
          'marcioleite.oxigenio@gmail.com',
          'rafaellatrigueiro@gmail.com',
          'rgasparotto@gmail.com',
          'sarah_cf@hotmail.com',
          'camilamariacr@gmail.com',
          'DR.HYANEMENEZES@GMAIL.COM',
          'ismeniacavalcante@gmail.com',
          'roseanemascarenhas81@gmail.com',
          'sayonarafisioterapeuta@gmail.com',
          'vaninalobo@hotmail.com',
          'deboraft@gmail.com',
          'giordanialess@hotmail.com',
          'anacor.morais@gmail.com',
          'arielle@programabemnascer.com.br',
          'danielamameri@gmail.com',
          'fernandagadia@gmail.com',
          'fernandaasilva15@gmail.com',
          'freitasgabifisio@gmail.com',
          'patricia.urogineco@gmail.com',
          'catarinattp@gmail.com',
          'danifscordeiro@gmail.com',
          'diaslailinha@gmail.com',
          'hellenmiranda.fisio@gmail.com',
          'karolinebeatriztavares@gmail.com',
        ],
      },
    },
    {
      nome: BLOQUEAR_GUIA,
      perfil: {
        permitir: [
          PERFIL.RECEPCIONISTA,
          PERFIL.FATURISTA,
          PERFIL.GERENTE,
          PERFIL.ADMINISTRADOR,
        ],
      },
    },
    {
      nome: DESBLOQUEAR_GUIA,
      perfil: {
        permitir: [PERFIL.FATURISTA, PERFIL.GERENTE, PERFIL.ADMINISTRADOR],
      },
    },
    {
      nome: TROCAR_SENHA,
      perfil: {
        permitir: [PERFIL.ADMINISTRADOR],
      },
    },
    {
      nome: EVOLUCAO_PACIENTE,
      perfil: {
        permitir: [
          PERFIL.FATURISTA,
          PERFIL.GERENTE,
          PERFIL.ADMINISTRADOR,
          PERFIL.SUPERVISAO,
          PERFIL.PROFISSIONAL,
        ],
      },
    },
    {
      nome: ALTERAR_GUIA_AGENDAMENTO,
      perfil: {
        permitir: [
          PERFIL.RECEPCIONISTA,
          PERFIL.FATURISTA,
          PERFIL.GERENTE,
          PERFIL.ADMINISTRADOR,
          PERFIL.SUPERVISAO,
        ],
      },
    },
  ],
}
